import React, { useEffect, useState } from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Button from "../components/Button/Button.js";

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const uid = useStore((state) => state.uid);
  const character = useStore((state) => state.character);
  // const setCharacter = useStore((state) => state.setCharacter);
  const gameState = useStore((state) => state.gameState);
  const sessionData = useStore((state) => state.sessionData);
  const checkRole = useStore((state) => state.checkRole);
  const checkinCharacter = useStore((state) => state.checkinCharacter);

  const [roleTaken, setRoleTaken] = useState(false);

  useEffect(() => {
    if (!character) return;
    const taken = checkRole(character);

    if (taken !== roleTaken) {
      setRoleTaken(taken);
    }
  }, [sessionData, character]);

  console.log("Character", character);

  if (!character) return null;

  return (
    <div className={`Page${props.className ? " " + props.className : ""}`}>
      <h1>{getLocalized("character", "Name")}</h1>
      <div>{getLocalized("character", "Subline")}</div>

      {character?.Profilbild?.data?.attributes?.url && (
        <img
          src={
            process.env.REACT_APP_CMS_URL +
            character.Profilbild.data.attributes.url
          }
          alt={character.Name}
        />
      )}

      {getLocalized("character", "Profile")?.length > 0 && (
        <div>
          {<BlocksRenderer content={getLocalized("character", "Profile")} />}
        </div>
      )}

      {getLocalized("character", "About")?.length > 0 && (
        <div>
          {<BlocksRenderer content={getLocalized("character", "About")} />}
        </div>
      )}

      {getLocalized("character", "NobodyKnows")?.length > 0 && (
        <div>
          {
            <BlocksRenderer
              content={getLocalized("character", "NobodyKnows")}
            />
          }
        </div>
      )}

      {gameState === -1 && (
        <Button
          className={`takeRole${roleTaken ? " inActive" : ""}`}
          onClick={() =>
            roleTaken ? null : checkinCharacter(character, !roleTaken)
          }
        >
          {roleTaken
            ? getLocalized("texts", "RolleAngenommen")
            : getLocalized("texts", "RolleAnnehmen")}{" "}
        </Button>
      )}
    </div>
  );
};

export default Page;
